(function () {
  if (window.__cartAnnouncementBarInit) return;
  window.__cartAnnouncementBarInit = true;

  function prefersReducedMotion() {
    try {
      return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    } catch (e) {
      return false;
    }
  }

  function init(root) {
    if (!root || root.dataset.cabReady === '1') return;

    var track = root.querySelector('[data-cab-track]');
    var slides = root.querySelectorAll('[data-cab-slide]');
    var n = slides.length;
    if (!track || n === 0) return;

    root.dataset.cabReady = '1';

    var autoplay = root.getAttribute('data-autoplay') === 'true' && !prefersReducedMotion();
    var interval = parseInt(root.getAttribute('data-interval'), 10) || 5000;
    var transitionMs = parseInt(root.getAttribute('data-transition'), 10) || 400;
    var pauseHover = root.getAttribute('data-pause-hover') === 'true';
    var loop = root.getAttribute('data-loop') !== 'false';

    var index = 0;
    var timer = null;
    var cleanupFns = [];

    function setTransition(enabled) {
      track.style.transitionDuration = enabled ? transitionMs + 'ms' : '0ms';
    }

    function goTo(i, animate) {
      if (n <= 1) return;
      if (!loop) {
        i = Math.max(0, Math.min(n - 1, i));
      } else {
        i = ((i % n) + n) % n;
      }
      index = i;
      setTransition(animate !== false);
      track.style.transform = 'translateX(-' + index * 100 + '%)';

      var dots = root.querySelectorAll('[data-cab-dot]');
      for (var d = 0; d < dots.length; d++) {
        dots[d].setAttribute('aria-current', d === index ? 'true' : 'false');
      }
    }

    function next() {
      goTo(index + 1);
    }

    function prev() {
      goTo(index - 1);
    }

    function clearTimer() {
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
    }

    function startTimer() {
      clearTimer();
      if (!autoplay || n <= 1) return;
      timer = setInterval(next, interval);
    }

    var prevBtn = root.querySelector('[data-cab-prev]');
    var nextBtn = root.querySelector('[data-cab-next]');

    function onPrev() {
      prev();
      clearTimer();
      startTimer();
    }
    function onNext() {
      next();
      clearTimer();
      startTimer();
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', onPrev);
      cleanupFns.push(function () {
        prevBtn.removeEventListener('click', onPrev);
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', onNext);
      cleanupFns.push(function () {
        nextBtn.removeEventListener('click', onNext);
      });
    }

    root.querySelectorAll('[data-cab-dot]').forEach(function (dot) {
      function onDot() {
        var idx = parseInt(dot.getAttribute('data-cab-dot'), 10);
        if (!isNaN(idx)) {
          goTo(idx);
          clearTimer();
          startTimer();
        }
      }
      dot.addEventListener('click', onDot);
      cleanupFns.push(function () {
        dot.removeEventListener('click', onDot);
      });
    });

    if (pauseHover && n > 1) {
      function enter() {
        clearTimer();
      }
      function leave() {
        startTimer();
      }
      root.addEventListener('mouseenter', enter);
      root.addEventListener('mouseleave', leave);
      root.addEventListener('focusin', enter);
      root.addEventListener('focusout', leave);
      cleanupFns.push(function () {
        root.removeEventListener('mouseenter', enter);
        root.removeEventListener('mouseleave', leave);
        root.removeEventListener('focusin', enter);
        root.removeEventListener('focusout', leave);
      });
    }

    goTo(0, false);
    startTimer();

    root._cartAnnouncementCleanup = function () {
      clearTimer();
      cleanupFns.forEach(function (fn) {
        fn();
      });
      cleanupFns = [];
      delete root.dataset.cabReady;
    };
  }

  function scan(container) {
    var scope = container || document;
    scope.querySelectorAll('[data-cart-announcement-bar]').forEach(init);
  }

  document.addEventListener('DOMContentLoaded', function () {
    scan();
  });

  document.addEventListener('shopify:section:load', function (ev) {
    if (ev.target && ev.target.querySelectorAll) {
      ev.target.querySelectorAll('[data-cart-announcement-bar]').forEach(function (root) {
        if (root._cartAnnouncementCleanup) root._cartAnnouncementCleanup();
        init(root);
      });
    }
  });
})();
